/* eslint-disable camelcase */
import { trim } from 'ramda';

import { groupSlotsByDate } from '../../helpers/slots.helpers';
import { ISlot } from '../meeting/meeting.types';
import { TCountry } from '../../../../store/countries/countries.types';

import { IClaimParams, IClaimFlags, IClaimRequestData } from './claim.types';

const getDaySlots = (slots: ISlot[]) => slots.map(item => ({ start_at: item.startAt, end_at: item.endAt }));

export const prepareClaimData = (
  { product, timezone, slots, notes, prospects, shipping }: IClaimParams,
  { doResubscribe, hasIntegration }: IClaimFlags,
  country?: TCountry,
): IClaimRequestData => {
  const hasMeeting = slots && slots.length > 0;

  const data: IClaimRequestData = {
    product_id: product.id,
    do_resubscribe: doResubscribe,
    verified_address: null,
  };

  if (hasMeeting) {
    const slot = slots[0];
    data.prospects = { date: slot.startAt, meeting_notes: trim(notes) };
  }

  if (hasMeeting && hasIntegration) {
    const slot = slots[0];
    data.schedule_meeting = {
      timezone,
      slot: {
        from: slot.startAt,
        to: slot.endAt,
      },
    };
  }

  if (hasMeeting && !hasIntegration) {
    const days = groupSlotsByDate(timezone)(slots);
    data.free_meetings = {
      timezone,
      days: Object.entries(days).map(([date, meetingSlots]) => ({ date, slots: getDaySlots(meetingSlots) })),
    };
  }

  if (prospects) {
    data.prospects = {
      ...(data.prospects || {}),
      ...prospects,
    };
  }

  if (shipping && product.isAddressRequired) {
    const { country: country_id, state, ...rest } = shipping.address;
    data.address = {
      country_id,
      state,
      state_code: country?.states?.find(item => item.name === state)?.abbreviation,
      ...rest,
    };
    data.verified_address = shipping.verifiedAddress;
  }

  if (product.options) {
    data.options = product.options;
    data.options_data = Object.entries(product.optionsData ?? {}).map(([attribute, value]) => ({
      attribute,
      value,
    }));
  }

  return data;
};
